import { createFileRoute } from "@tanstack/react-router";
import { TourCentre } from "@/tours/TourCentre";

export const Route = createFileRoute("/_app/tours/")({ component: TourCentre });
